// src/components/wizard/CustomDStep.js
import React from "react";
import { Box, Typography } from "@mui/material";

import BulletPont from "../../views/pages/manage/unAssigned/collectPayment/stepper/BulletPont.jsx";

export default function CustomDStep({
  steps,
  currentStep,
  back,
  stepsConfig,
  isStepperNavigationAllowed,
}) {
  return (
    <Box
      display="flex"
      border="1px solid #ddd"
      borderRadius="8px"
      overflow="hidden"
      marginLeft="15px"
      marginRight="15px"
    >
      {steps
        .filter((step) => !step.includes("Search"))
        .map((label, idx) => {
          const isActive = idx === currentStep;
          let bgColor = isActive ? "#00B0F5" : "#fff";
          let txtColor = isActive ? "#fff" : "#333333";

          const stepInfo = stepsConfig[idx];
          const isDisabled = stepInfo?.disabled;
          if (isDisabled) txtColor = "#0000001a";

          const goBack =
            idx < currentStep && !isDisabled ? () => back(idx) : () => {};

          return (
            <Box
              key={label}
              flex={1}
              display="flex"
              alignItems="center"
              px={2}
              py={1}
              bgcolor={bgColor}
              onClick={() => isStepperNavigationAllowed && goBack()}
              sx={{ "&:not(:last-of-type)": { borderRight: "1px solid #ddd" } }}
            >
              <BulletPont
                step={idx + 1}
                isActive={isActive}
                currentStep={currentStep}
                isDisabled={isDisabled}
              />

              <Typography
                variant="body2"
                sx={{
                  color: txtColor,
                  whiteSpace: "nowrap",
                  marginLeft: "8px",
                }}
              >
                {label}
              </Typography>
            </Box>
          );
        })}
    </Box>
  );
}
